import { ITheme } from '../../models/ITheme';
import { TextTheme } from '../sodimac/TextTheme';
import { ButtonTheme } from './ButtonTheme';
import { calculatorTheme } from './CalculatorTheme';
import { inputSpinnerTheme } from './inputSpinnerTheme';
import { inputTheme } from './inputTheme';
import { RatingTheme } from './RatingTheme';

export const theme: ITheme = {
  Button: { ...ButtonTheme },
  Rating: { ...RatingTheme },
  Text: { ...TextTheme },
  Input: { ...inputTheme },
  InputSpinner: { ...inputSpinnerTheme },
  Calculator: { ...calculatorTheme },
} as const;
